import { Component, inject } from '@angular/core';
import { Status } from '../../../services/status';
import { FallaufgabenService } from '../../../services/fallaufgaben-service';
import { Dialog } from "primeng/dialog";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "primeng/tabs";
import { Button } from "primeng/button";
import { SessionDetailsService } from './session-details.service';
import { CommonModule, DatePipe } from '@angular/common';
import { TableModule } from "primeng/table";
import { FormsModule } from '@angular/forms';

// TODO: Remove once @reflact/ipkv-types is updated with LearningGuidanceDebugTrace
type LearningGuidanceDebugTrace = {
  generatedAt: string;
  inputFeedbackText: string;
  kiScore: number | null;
  weakPointsPrompt: string;
  weakPointsResponse: string;
  weakPoints: { description: string; aufgabenNummer: string; relevanceScore: number }[];
  chunksFound: { chunkId: string; content: string; chapterId: string; similarity?: number }[];
  explanationPrompt: string;
  explanationResponse: string;
};

@Component({
  selector: 'app-session-details',
  standalone: true,
  imports: [CommonModule, Dialog, Tabs, TabList, Tab, TabPanels, TabPanel, Button, DatePipe, TableModule, FormsModule],
  templateUrl: './session-details.component.html',
  styleUrl: './session-details.component.scss'
})
export class SessionDetailsComponent {

  protected fallaufgabenService = inject(FallaufgabenService);
  protected statusService = inject(Status);
  public sessionDetailsService = inject(SessionDetailsService);

  editableExplanationPrompt: string = '';
  regeneratedExplanation: string | null = null;
  hasRegeneratedExplanation = false;
  isRegenerating = false;
  private lastDebugTraceStatusId: string | null = null;

  get debugTrace(): LearningGuidanceDebugTrace | undefined {
    const trace = (this.statusService.selectedStatus as any).learningGuidanceDebugTrace;
    const currentStatusId = this.statusService.selectedStatus?._id ?? null;

    if (currentStatusId !== this.lastDebugTraceStatusId) {
      this.lastDebugTraceStatusId = currentStatusId;
      this.editableExplanationPrompt = trace?.explanationPrompt ?? '';
      this.regeneratedExplanation = null;
      this.hasRegeneratedExplanation = false;
    }
    return trace;
  }

  constructor() { }

  async regenerateExplanation() {
    if (!this.editableExplanationPrompt || this.isRegenerating) {
      return;
    }

    this.isRegenerating = true;
    this.regeneratedExplanation = null;

    try {
      this.regeneratedExplanation = await this.sessionDetailsService.regenerateExplanation(
        this.editableExplanationPrompt
      );
      this.hasRegeneratedExplanation = true;
    } catch (error) {
      console.error('Regeneration failed:', error);
      this.regeneratedExplanation = `Fehler beim Regenerieren: ${error}`;
      this.hasRegeneratedExplanation = true;
    } finally {
      this.isRegenerating = false;
    }
  }

}
